/**
 * HPE B2C 4076 — Primary header updates after the September 2026 release
 *
 * 1. Hides the primary header search icon button (CSS in 4076.css).
 * 2. Points the HPE logo button at the buy.hpe.com homepage for the current
 *    country/language (e.g. https://buy.hpe.com/us/en).
 * 3. Shows "Store" next to the HPE logo through the header's native microsite
 *    title slot, linked to the same store homepage.
 *
 * ClickUp: https://app.clickup.com/t/86e3dhzw0
 * ClickUp: https://app.clickup.com/t/86e3ga9wq
 */
(function () {
   try {

      const BODY_CLASS = 'fe-hpe-4076';
      const STORE_ORIGIN = 'https://buy.hpe.com';
      const ACTIVE_CLASS = 'hpehf-active';

      const txt = {
         Store: 'Store',
      };

      const SelectorsDictionary = {
         Body: 'body',
         SearchIconTrigger: 'li#hpehf-search',
         HpeLogo: '.hpehf-main-nav a#hpehf-hpe-logo',
         MicrositeTitleArea: '.hpehf-main-nav a#hpehf-microsite-title-area',
         MicrositeTitle: '.hpehf-main-nav #hpehf-microsite-title',
      };

      /**
       * Logs through the loader logger when it is callable on this page.
       * @param {string} message
       */
      function log(message) {
         if (typeof window.feHPEB2C?.log === 'function') {
            window.feHPEB2C.log(`${feProjectId}: ${message}`);
         }
      }

      /**
       * Adds the activity body class as a marker (the hide rule in 4076.css is unscoped).
       */
      function hideSearchIcon() {
         document.body.classList.add(BODY_CLASS);
         log('search icon hidden');
      }

      /**
       * Rewrites the HPE logo link to the homepage for the current country/language.
       */
      function updateLogoLink() {
         const logo = document.querySelector(SelectorsDictionary.HpeLogo);
         const baseUrl = window.feHPEB2C?.baseUrl?.();

         if (!logo || !baseUrl) return;

         logo.href = `${STORE_ORIGIN}${baseUrl}`;
         log(`logo link set to ${logo.href}`);
      }

      /**
       * Fills the header's native microsite title slot with "Store". Adding the native
       * active class lets the header stylesheet handle font, size, spacing and dark theme.
       */
      function showStoreTitle() {
         const area = document.querySelector(SelectorsDictionary.MicrositeTitleArea);
         const title = document.querySelector(SelectorsDictionary.MicrositeTitle);
         const baseUrl = window.feHPEB2C?.baseUrl?.();

         if (!area || !title) return;

         title.textContent = txt.Store;
         area.classList.add(ACTIVE_CLASS);
         // Native target is the hpe.com corporate homepage; match the logo instead.
         if (baseUrl) area.href = `${STORE_ORIGIN}${baseUrl}`;
         log('store title shown');
      }

      // Independent waits: a missing logo must not stop the search icon from hiding.
      window.feUtils.waitForConditions({
         conditions: [SelectorsDictionary.Body],
         activity: feProjectId,
         callback: hideSearchIcon,
      });

      window.feUtils.waitForConditions({
         conditions: [SelectorsDictionary.HpeLogo],
         activity: feProjectId,
         callback: updateLogoLink,
      });

      window.feUtils.waitForConditions({
         conditions: [SelectorsDictionary.MicrositeTitleArea, SelectorsDictionary.MicrositeTitle],
         activity: feProjectId,
         callback: showStoreTitle,
      });

   } catch (e) { console.error(e); }
})();
